export default __webpack_public_path__ + "static/media/hsycbh_blue.d586e52e.svg";